var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.523 8.934a.7.7 0 0 1-.59.428l-4.75.379a.7.7 0 0 0-.399 1.23L7.4 14.055a.7.7 0 0 1 .226.696L6.52 19.365a.7.7 0 0 0 1.045.761l4.071-2.477a.7.7 0 0 1 .728 0l4.071 2.477a.7.7 0 0 0 1.045-.76l-1.105-4.615a.7.7 0 0 1 .226-.696l3.615-3.084a.7.7 0 0 0-.399-1.23l-4.75-.38a.7.7 0 0 1-.59-.427l-1.831-4.387a.7.7 0 0 0-1.292 0L9.523 8.934Zm6.495-1.503-1.526-3.655c-.924-2.212-4.06-2.212-4.983 0L7.983 7.431l-3.96.316c-2.396.192-3.366 3.185-1.537 4.746l3.009 2.567-.92 3.84c-.559 2.334 1.979 4.183 4.03 2.935L12 19.769l3.396 2.066c2.05 1.248 4.588-.601 4.029-2.936l-.92-3.84 3.009-2.566c1.83-1.561.86-4.554-1.538-4.746l-3.958-.316Z",
    fill: "#777E91"
  })));
};
export default SvgLine;